@if (searchService.search_loading) {
  <app-loading-screen icon="custom_icon-apartment" [animated]="animated">
    <span title i18n="@@apartment_loading_title">Just loading your search results</span>
    <div msgOne>
      <span i18m="@@long_stay_loading_from">Long Stay In</span>
      {{ searchParams.town.name | titlecase }}
    </div>
    <span msgTwo i18n="@@apartment_loading_msg2"> Checking for availability </span>
  </app-loading-screen>
}
